import React from 'react';
import { C } from '../../utils/styles';
import Icon from '../Icon';
import { ALL_FILTERABLE_STAGES, TIME_PERIODS } from '../../utils/dashboardData';

const SELECT_STYLE = {
  padding: '8px 30px 8px 12px',
  background: '#fff',
  border: `1px solid ${C.border}`,
  borderRadius: 8,
  color: C.text,
  fontSize: 13,
  fontWeight: 600,
  fontFamily: 'inherit',
  outline: 'none',
  cursor: 'pointer',
  appearance: 'none',
  minWidth: 180,
  backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='none' stroke='%234a5568' stroke-width='1.5' d='M1 1l4 4 4-4'/></svg>\")",
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 10px center',
};

export default function DashboardFilterBar({
  filters,
  onChange,
  onClear,
  amOptions = [],
  stateOptions = [],
  isSuperUser = false,
  currentAmName = '',
}) {
  const update = (patch) => onChange({ ...filters, ...patch });
  const activeCount = [
    filters.amId && filters.amId !== 'all' ? 1 : 0,
    filters.state && filters.state !== 'all' ? 1 : 0,
    filters.stage && filters.stage !== 'all' ? 1 : 0,
    filters.timePeriod && filters.timePeriod !== 'all' ? 1 : 0,
  ].reduce((a, b) => a + b, 0);

  return (
    <div
      data-testid="dashboard-filter-bar"
      style={{
        background: '#fff', border: `1px solid ${C.border}`, borderRadius: 12,
        padding: '14px 18px',
        display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 700, color: C.textMid, letterSpacing: '0.05em', textTransform: 'uppercase' }}>
        <Icon name="options-outline" style={{ fontSize: 16, color: C.accent }} />
        Filters
      </div>

      {/* Account Manager */}
      {isSuperUser ? (
        <select
          data-testid="dashboard-filter-am"
          value={filters.amId || 'all'}
          onChange={(e) => update({ amId: e.target.value })}
          style={SELECT_STYLE}
        >
          <option value="all">All account managers</option>
          {amOptions.map((a) => {
            const label = a.count ? `${a.name} (${a.count})` : a.name;
            return (
              <option key={a.id} value={a.id}>{label}</option>
            );
          })}
        </select>
      ) : (
        <div
          data-testid="dashboard-filter-am-locked"
          style={{
            ...SELECT_STYLE,
            background: C.bg,
            color: C.textMid,
            cursor: 'not-allowed',
            backgroundImage: 'none',
            paddingRight: 12,
            display: 'flex', alignItems: 'center', gap: 6,
          }}
          title="Account managers see only their own book"
        >
          <Icon name="lock-closed-outline" style={{ fontSize: 13 }} />
          {currentAmName || 'My book'}
        </div>
      )}

      {/* State */}
      <select
        data-testid="dashboard-filter-state"
        value={filters.state || 'all'}
        onChange={(e) => update({ state: e.target.value })}
        style={SELECT_STYLE}
      >
        <option value="all">All states</option>
        {stateOptions.map((s) => {
          const label = `${s.state} (${s.employees.toLocaleString()} employees)`;
          return (
            <option key={s.state} value={s.state}>{label}</option>
          );
        })}
      </select>

      {/* Stage */}
      <select
        data-testid="dashboard-filter-stage"
        value={filters.stage || 'all'}
        onChange={(e) => update({ stage: e.target.value })}
        style={SELECT_STYLE}
      >
        <option value="all">All stages</option>
        {ALL_FILTERABLE_STAGES.map((s) => (
          <option key={s.id} value={s.id}>{s.label}</option>
        ))}
      </select>

      {/* Time Period */}
      <select
        data-testid="dashboard-filter-period"
        value={filters.timePeriod || 'all'}
        onChange={(e) => update({ timePeriod: e.target.value })}
        style={SELECT_STYLE}
      >
        {TIME_PERIODS.map((p) => (
          <option key={p.id} value={p.id}>{p.label}</option>
        ))}
      </select>

      <div style={{ flex: 1 }} />

      {/* Active count + clear */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 12 }}>
        {activeCount > 0 && (
          <span data-testid="dashboard-filter-active-count" style={{ color: C.textMid, fontWeight: 600 }}>
            {activeCount} filter{activeCount !== 1 ? 's' : ''} active
          </span>
        )}
        {activeCount > 0 && (
          <button
            type="button"
            data-testid="dashboard-filter-clear"
            onClick={onClear}
            style={{
              background: 'transparent', border: 'none', color: C.accent,
              fontSize: 12, fontWeight: 700, cursor: 'pointer', padding: 0,
              textDecoration: 'underline', textUnderlineOffset: 3,
            }}
          >
            Clear all
          </button>
        )}
      </div>
    </div>
  );
}
